import React, {useEffect, useState} from "react";
import Layout from "../Shared/Layout";
import {Container, Grid, Paper, TextField} from "@material-ui/core";
import styled from "styled-components";
import {Trans} from "../utils/i18n";
import AccordionList from "../Shared/AccordionList";
import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';

const Wrapper = styled.div``;

export default function Faq({lang, faqs, faqCategories, openFirst}) {

    const [activeCategory, setActiveCategory] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredFaqs, setFilteredFaqs] = useState(faqs);

    useEffect(() => {
        let _faqs = faqs;
        _faqs = _faqs.filter(faq => {
            if (activeCategory.length === 0) {
                return true;
            }
            return activeCategory.includes(faq?.category_id)
        });

        let searchedWords = searchQuery.split(' ')
            .filter(w => w.trim() !== '');

        if (searchedWords.length) {
            _faqs = _faqs.filter(faq => {
                return searchedWords.some(function (w) {
                    return faq.question.includes(w) || faq.answer.includes(w);
                });
            })
        }

        setFilteredFaqs(_faqs);
    }, [searchQuery, activeCategory])

    return (
        <Wrapper>
            <Container maxWidth="lg">
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={12}>
                        <h1>
                            <Trans i18nKey={"faq.FrequentlyAskQuestions"}>
                                Frequently Asked Questions
                            </Trans>
                        </h1>
                        <Grid container spacing={3} className="mt-8">
                            <Grid item xs={4} sm={3}>
                                <List
                                    key={`list-main`}
                                    dense={true}
                                    sx={{width: '100%'}}
                                    component="nav"
                                    subheader={
                                        <ListSubheader component="div" id="categories-subheader">
                                            <Trans
                                                i18nKey={"faq.categories"}
                                            >Categories</Trans>
                                        </ListSubheader>
                                    }
                                >
                                    <ListItemButton selected={activeCategory.length === 0}
                                                    onClick={() => setActiveCategory([])}>
                                        <ListItemText primary={<Trans i18nKey={"queues.all"}>Categories</Trans>}/>
                                    </ListItemButton>
                                    {faqCategories.map((item) => (
                                        <>
                                            <ListItemButton key={`list-item-${item.id}`}
                                                            selected={activeCategory.includes(item.id)}
                                                            onClick={() => setActiveCategory([item.id])}>
                                                <ListItemText primary={item.name}/>
                                            </ListItemButton>
                                            {item.children.length ? item.children.map(child_item => {
                                                return <List key={`list-${item.id}-${child_item.id}`} dense={true}
                                                             component="div" disablePadding>
                                                    <ListItemButton key={`list-item-${item.id}-${child_item.id}`}
                                                                    sx={{pl: 2}}
                                                                    selected={activeCategory.includes(child_item.id)}
                                                                    onClick={() => setActiveCategory([item.id, child_item.id])}>
                                                        <ListItemText primary={" - " + child_item.name}/>
                                                    </ListItemButton>
                                                </List>
                                            }) : ''}
                                        </>
                                    ))}
                                </List>
                            </Grid>
                            <Grid item xs={8} sm={9}>
                                <TextField
                                    required={true}
                                    id="search"
                                    name="search"
                                    label={<Trans
                                        i18nKey={"faq.search"}
                                    >
                                        Search
                                    </Trans>}
                                    value={searchQuery}
                                    onChange={(e) => setSearchQuery(e.target.value)}
                                    variant="outlined"
                                    type="search"
                                    style={{marginBottom: '30px'}}
                                />
                                <AccordionList items={filteredFaqs} activeCategory={activeCategory}
                                               openFirst={openFirst}/>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Container>
        </Wrapper>
    );
}

Faq.layout = (page) => <Layout children={page}/>;
